import * as React from "react";
import { cn } from "@/lib/cn";

// Badge — keep the "chrome" tone for admin-shell call-outs and add
// neon-friendly mappings for everything else.
type Tone =
  | "default"
  | "success"
  | "warning"
  | "danger"
  | "muted"
  | "accent"
  | "chrome";

const tones: Record<Tone, string> = {
  default: "pill neutral",
  muted: "pill neutral",
  success: "pill yes",
  warning: "pill warn",
  danger: "pill no",
  accent: "pill accent",
  // Chrome — slightly cooler chrome look using the cyan tint, so it's
  // still distinguishable from the default neutral pill on dark
  // surfaces.
  chrome:
    "inline-flex items-center gap-1 rounded-full border border-cyan/30 bg-cyan/10 px-2 py-0.5 text-2xs font-semibold uppercase tracking-wide text-cyan",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

export function Badge({ tone = "default", className, ...rest }: BadgeProps) {
  return <span className={cn(tones[tone], "uppercase", className)} {...rest} />;
}
